<template lang="pug">
.listing-comment-item.my-3
  //- Comment section
  v-row(no-gutters)
    v-col(:cols="offsetCols" :xl="offsetXlCols" :class="{'mr-8':isLargerScreen}")
    //- No idea why offset not working here
    v-col
      .text-sm.font-normal.mr-6 {{ comment }}
</template>

<script>
export default {
  name: 'ListingCommentItem',
  props: {
    offsetCols: {
      type: Number,
      default: 2 
    },
    comment: {
      type: String,
      default: null 
    },
  },
  computed: {
    offsetXlCols() {
      return this.offsetCols - 1
    },
    isLargerScreen() {
      return this.$vuetify.breakpoint.xl
    },
  },
}
</script>

<style scoped>
</style>
